import React, { useEffect, useState } from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import SEO from "../../components/SEO";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import clsx from "clsx";

import "swiper/css";
import "swiper/css/autoplay";

import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import Link from "../../components/v2/Link";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import FaqSection from "../../components/v4/FaqSection/FaqSection";

import broadcastImg1 from "../../images/v4/user-based-tools/accountingAndFinance/images/broadcastImg1.webp";
import broadcastImg2 from "../../images/v4/user-based-tools/accountingAndFinance/images/broadcastImg2.webp";

import whiteCheckCircle1 from "../../images/v4/user-based-tools/accountingAndFinance/icons/whiteCheckCircle1.svg";
import whiteCheckCircle2 from "../../images/v4/user-based-tools/accountingAndFinance/icons/whiteCheckCircle2.svg";

import adaptImg1 from "../../images/v4/salesManagers/clientSlider/img1.png";
import adaptImg2 from "../../images/v4/salesManagers/clientSlider/img2.png";
import adaptImg3 from "../../images/v4/salesManagers/clientSlider/img3.png";
import adaptImg4 from "../../images/v4/salesManagers/clientSlider/img4.png";
import adaptImg5 from "../../images/v4/salesManagers/clientSlider/img5.png";
import adaptImg6 from "../../images/v4/salesManagers/clientSlider/img6.png";
import adaptImg7 from "../../images/v4/salesManagers/clientSlider/img7.png";

import growingIcon1 from "../../images/v4/user-based-tools/accountingAndFinance/icons/growingIcon1.svg";
import growingIcon2 from "../../images/v4/user-based-tools/accountingAndFinance/icons/growingIcon2.svg";
import growingIcon3 from "../../images/v4/user-based-tools/accountingAndFinance/icons/growingIcon3.svg";
import growingIcon4 from "../../images/v4/user-based-tools/accountingAndFinance/icons/growingIcon4.svg";

import benefit1Icon1 from "../../images/v4/user-based-tools/accountingAndFinance/icons/benefit1Icon1.svg";
import benefit1Icon2 from "../../images/v4/user-based-tools/accountingAndFinance/icons/benefit1Icon2.svg";
import benefit1Icon3 from "../../images/v4/user-based-tools/accountingAndFinance/icons/benefit1Icon3.svg";
import benefit1Icon4 from "../../images/v4/user-based-tools/accountingAndFinance/icons/benefit1Icon4.svg";
import benefit1Img from "../../images/v4/user-based-tools/accountingAndFinance/images/benefit1Img.webp";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import heroSectionImg from "../../images/v4/user-based-tools/accountingAndFinance/images/heroSectionImg.webp";
import heroSectionBg from "../../images/v4/user-based-tools/accountingAndFinance/images/heroSectionBg.png";
import growingBussinessBg from "../../images/v4/user-based-tools/accountingAndFinance/images/growingBussinessBg.png";
import combineSectionBg from "../../images/v4/user-based-tools/accountingAndFinance/images/combineSectionBg.png";
import compareBg from "../../images/v4/user-based-tools/messagingCommunication/images/compareBg.png";

import compareItemImg1 from "../../images/v4/user-based-tools/accountingAndFinance/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/user-based-tools/accountingAndFinance/images/compareItemImg2.webp";
import compareItemImg3 from "../../images/v4/user-based-tools/accountingAndFinance/images/compareItemImg3.webp";
import compareItemImg4 from "../../images/v4/user-based-tools/accountingAndFinance/images/compareItemImg4.webp";
import compareItemImg5 from "../../images/v4/user-based-tools/accountingAndFinance/images/compareItemImg5.webp";

const useStyles = makeStyles((theme) => ({
  whatsappSection: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "60px 0 0 0",
    borderRadius: "0 0 30px 30px",
    backgroundImage: `url(${heroSectionBg})`,
    marginBottom: "50px",
    "& $aiSectionLeft": {
      width: "53%",
      gap: "25px",
    },
    "& .countryHighlight": {
      background: "linear-gradient(90deg, #25D366 0%, #0D4D85 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .buttonContaienr": {
      marginTop: "20px",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "0",
      padding: "0",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px",
      backgroundPosition: "bottom",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      marginBottom: "0",
      "& $aiSectionLeft": {
        width: "100%",
        gap: "16px",
        "&  .wpLogo": {
          width: "40px",
          height: "40px",
          position: "relative",
          top: "10px",
        },
      },
      paddingTop: "0px",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
      "& .buttonContaienr": {
        marginTop: "10px",
      },
    },
  },
  aiSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "10px",
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "20px",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    // "&  .wpLogo": {
    //   width: "40px",
    //   height: "40px",
    //   position: "relative",
    //   top: "10px",
    // },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "50%",
    "& img": {
      transform: "translateY(14%)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },

  Client: {
    position: "relative",
    zIndex: "10",
    // backgroundImage: `url(${clientbg})`,
    // backgroundRepeat: "no-repeat",
    // backgroundSize: "cover",
    // backgroundPosition: "top",
    background: "#FFFFFF",
    "@media(max-width:1024px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "25px!important",
        },
      },
    },

    "@media(max-width:600px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "20px!important",
        },
      },
    },

    "& p": {
      textAlign: "center",
      marginBottom: "64px",
      "@media(max-width:1024px)": {
        marginBottom: "32px",
      },

      "@media(max-width: 600px)": {
        marginBottom: "18px",
      },
    },
    "& .client-logo": {
      width: "auto!important",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "35px",
      },
    },
  },

  listContainer: {
    display: "flex",
    marginTop: "16px",
    width: "100%",
    flexWrap: "wrap",
    // flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      minWidth: "100%",
      gap: "8px",
      marginTop: "0",
    },
  },
  listItem: {
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid rgba(241, 223, 255, 0.40)",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {},
    // color: "#A2BED3",
  },

  broadcastContainer: {
    background: "#31114B",
    "& .centerContainer": {
      display: "flex",
      justifyContent: "space-between",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      // textAlign: "center",
      "& h2": {
        flex: 1,
      },
    },
    "@media only screen and (max-width:  768px)": {
      "& .centerContainer": {
        flexDirection: "column",
      },
    },

    "& $broadcastRightContainer": {
      width: "50%",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
      "& $broadcastRightContainer": {
        width: "100%",
      },
    },
  },

  benefitSection1: {
    background: "#E0EFFD",
    "& .centerContainer": {
      display: "flex",
      justifyContent: "space-between",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      // textAlign: "center",
      "& h2": {
        flex: 1,
      },
    },
    "@media only screen and (max-width:  768px)": {
      "& .centerContainer": {
        flexDirection: "column",
      },
    },

    "& .benefits": {
      display: "flex",
      justifyContent: "space-between",
      gap: "20px",
      margin: "60px 0",
      "& .imageColumn": {
        width: "94.5%",

        "& img": {
          width: "100%",
        },
      },

      "& .featureColumn": {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        width: "92%",
        "& .featureContainer": {
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          gap: "22px",
          boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
          borderRadius: "16px",
          background: "#fff",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          textAlign: "left",
          marginBottom: "0",
          minHeight: "48%",
          "& p": {
            // color: $black2,
            width: "90%",
          },
          "@media only screen and (max-width: 600px)": {
            width: "100%",
            minHeight: "0",
            "& p": {
              width: "100%",
            },
          },
        },
      },

      "@media only screen and (max-width:  768px)": {
        flexDirection: "column",
        gap: "20px",

        "& .imageColumn": {
          width: "100%",
        },

        "& .featureColumn": {
          width: "100%",
        },
      },
    },
  },

  workflowBroadcastContainerInner: {
    width: "100%",
    display: "flex",
    position: "relative",
    alignItems: "stretch",
    gap: "30px",
    padding: "0 4rem 4rem !important",
    overflow: "auto",
    justifyContent: "flex-start",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px 40px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "0 19rem 6rem !important",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  broadcastBox: {
    display: "flex !important",
    padding: "40px",
    background: "#009249",
    alignItems: "center",
    borderRadius: "20px",
    justifyContent: "space-between",
    minWidth: "70%",
    maxWidth: "70%",
    minHeight: "480px",
    maxHeight: "480px",
    // minHeight: "415px",
    // maxHeight: "415px",
    transition: "0.3s ease",
    overflow: "hidden",
    "&.active": {
      transform: "scale(1) !important",
    },
    "&.inActive": {
      transform: "scale(0.8) !important",
    },
    "@media only screen and (max-width: 1024px)": {
      maxHeight: "max-content",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px",
      gap: "15px",
      flexDirection: "column-reverse",
      minHeight: "780px",
      maxHeight: "max-content",
      justifyContent: "flex-end",
      minWidth: "90%",
      maxWidth: "90%",
    },
    "@media only screen and (min-width: 1800px)": {
      minWidth: "80%",
      maxWidth: "80%",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "55%",
    gap: "10px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastRightContainer: {
    width: "50%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  cardPointer: {
    display: "flex",
    marginTop: "2px",
    justifyContent: "flex-start",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "flex-start",
    },
  },
  cardPointerContent: {},

  growingBusiness: {
    backgroundImage: `url(${growingBussinessBg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "80px",
    position: "relative",
    "& .header": {
      width: "80%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      gap: "32px",
    },
    "& $featureContainer": {
      display: "flex",
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "50px",
      "& .header": {
        width: "100%",
      },
    },
  },
  broadcastContainerInner: {
    gap: "30px",
    width: "100%",
    display: "flex",
    padding: "1rem 16rem 0 16rem",
    paddingBottom: "16px !important",
    alignItems: "stretch",
    justifyContent: "flex-start",
    "& swiper-wrapper": {
      alignItems: "stretch !important",
    },

    "& $featureContainer": {
      width: "31%",
      height: "auto  !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "16px 15px !important",
    },
    // "@media only screen and (min-width: 1900px)": {
    //   paddingLeft: "40rem !important",
    //   paddingRight: "40rem !important",
    // },
  },
  featureContainer: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "32%",
    gap: "22px",
    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
    borderRadius: "16px",
    background: "#fff",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
    "& p": {
      // color: $black2,
      width: "90%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& p": {
        width: "100%",
      },
    },
  },

  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${combineSectionBg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    maxWidth: "1200px",
    margin: "0 auto 32px",

    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },

  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },

  compareSection: {
    backgroundImage: `url(${compareBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "top",
    paddingTop: "280px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "160px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },

  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
    },
  },

  faqDesc: {
    paddingBottom: "15px",
  },

  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",

    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "10px",
    },
  },

  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },

  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },

  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
}));

const AccountingAndFinance = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto-lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Sales Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];
    const logotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
        case 2:
          logotrack3.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
      logotrack3,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2, logotrack3 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo-2");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 25 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row-2").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const broadcastList = [
    {
      heading: "Xero CRM integration",
      content:
        "Connect Xero with Pepper Cloud CRM to create quotes faster, track updates easily, and sync your sales and finance teams effortlessly.",
      img: broadcastImg2,
      checkIcon: whiteCheckCircle1,
      alt: "QuickBooks CRM integration",
      background: "linear-gradient(180deg, #2788E7 0%, #783CA8 100%)",
      points: [
        {
          title: "Two-way quotation sync",
          description:
            "Access, create, and manage quotes from either Xero or Pepper Cloud CRM with real-time synchronisation.",
        },
        {
          title: "Ready-to-use templates",
          description:
            "Speed up quote creation with customisable templates that include your branding, pricing, and tax logic.",
        },
        {
          title: "Instant workflow notifications",
          description:
            "Get real-time email alerts on quotation status changes through workflow automation, helping you respond quickly.",
        },
      ],
    },
    {
      heading: "QuickBooks CRM integration",
      content:
        "Easily manage quotes and estimates with Pepper Cloud’s QuickBooks integration—real-time sync and automation keep sales and finance in step.",
      img: broadcastImg1,
      checkIcon: whiteCheckCircle2,
      alt: "Xero CRM system integration",
      background: "linear-gradient(180deg, #09939A 0%, #2787E7 100%)",
      points: [
        {
          title: "Easy setup and configuration",
          description:
            "Connect QuickBooks with Pepper Cloud CRM in just a few clicks — no coding or complex setup required.",
        },
        {
          title: "Real-time status updates",
          description:
            "Track the status of estimates across both systems. Whether accepted, declined, or pending, your CRM reflects it instantly.",
        },
        {
          title: "Auto-population of estimate data",
          description:
            " Instantly pull product details, pricing, and tax information from QuickBooks into the CRM to save time and avoid manual errors.",
        },
      ],
    },
  ];

  const growingList = [
    {
      icon: growingIcon1,
      heading: "Easy setup, no technical complexity",
      text: "Connect to QuickBooks or Xero in just a few clicks with guided integration—no coding required.",
    },
    {
      icon: growingIcon2,
      heading: "Two-way sync with real-time data updates",
      text: "Sync estimates and quotations between your CRM and accounting software automatically, so your sales and finance teams always work with the latest information.",
    },
    {
      icon: growingIcon3,
      heading: "Unified customer insights",
      text: "Combine financial data, sales activity, and communication history into one CRM and accounting software dashboard for a 360° customer view.",
    },
    {
      icon: growingIcon4,
      heading: "Scalable for growing businesses",
      text: "Whether you're managing a few clients or hundreds, Pepper Cloud’s flexible features support your growth without added complexity.",
    },
  ];

  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud offers one of the most seamless integrations with QuickBooks and Xero, making it the ideal CRM with accounting software for small and growing businesses. Built for usability and scale, it combines real-time financial data with a powerful sales engine, giving you full control over customer quotes, workflows, and follow-ups—all from a single dashboard.",
      img: compareItemImg1,
      alt: "Pepper Cloud CRM",
      features: [
        {
          title: "Two-way data synchronisation",
          desc: " Keep your quotations and financial records updated in real time between Pepper Cloud and your accounting tools, reducing manual effort.",
        },
        {
          title: "Auto-population of quotation details",
          desc: " Instantly pull in product, tax, and pricing data from QuickBooks or Xero—no manual input required.",
        },
        {
          title: "Real-time status tracking",
          desc: " View accepted, declined, or pending statuses from your CRM as soon as updates happen in your accounting system.",
        },
        {
          title: "Workflow automation and notifications",
          desc: "Set triggers and receive instant email alerts when quotations are modified, approved, or need attention.",
        },
        {
          title: "Custom templates and branding",
          desc: " Use pre-built, professional templates for sending branded quotations quickly and accurately.",
        },
        {
          title: "User-friendly, scalable platform",
          desc: " Easy to set up and intuitive to use, Pepper Cloud adapts to your business needs without the tech hassle.",
        },
      ],
    },
    {
      title: " Zoho CRM",
      desc: "Zoho CRM integrates with Zoho Books and other third-party accounting tools, making it suitable for startups and SMEs needing flexibility between sales and finance.",
      img: compareItemImg2,
      alt: " Zoho CRM",
      features: [
        {
          desc: "Supports invoice and quote generation directly from CRM",
        },
        {
          desc: "Basic automation workflows tied to deal stages",
        },
        {
          desc: "Integrates well within the Zoho ecosystem",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "While HubSpot doesn’t offer native accounting, it integrates with tools like QuickBooks and Xero through third-party apps, offering flexibility for marketing-driven teams.",
      img: compareItemImg3,
      alt: "HubSpot CRM",
      features: [
        {
          desc: "Easy sync of contacts and deals with QuickBooks",
        },
        {
          desc: "Invoice generation from deals using third-party connectors",
        },
        {
          desc: "Timeline view of financial and communication history",
        },
      ],
    },
    {
      title: "Salesforce CRM",
      desc: "Salesforce integrates with enterprise-grade tools like NetSuite and QuickBooks, making it ideal for large businesses that require deep customisation and reporting.",
      img: compareItemImg4,
      alt: "Salesforce CRM",
      features: [
        {
          desc: "Strong automation and approval processes",
        },
        {
          desc: "Integration with ERP systems for financial sync",
        },
        {
          desc: "Real-time dashboards and forecasting tools",
        },
      ],
    },
    {
      title: "Insightly CRM",
      desc: "Insightly offers accounting integrations via apps like QuickBooks and Xero, designed for project-based businesses and service providers.",
      img: compareItemImg5,
      alt: "Insightly CRM",

      features: [
        {
          desc: "Track invoices and payments alongside project milestones",
        },
        {
          desc: "Automatically associate financial data with CRM contacts",
        },
        {
          desc: "Simple sync setup via pre-built integrations",
        },
      ],
    },
  ];

  const faqs = [
    {
      question: "What is CRM accounting software?",
      answer: (
        <>
          CRM accounting software refers to the integration of customer
          relationship management tools with accounting platforms. It helps
          businesses manage client interactions, quotes, and financial data in
          one system—reducing manual work and improving accuracy.
        </>
      ),
    },
    {
      question: "Why should I integrate my CRM with accounting software?",
      answer: (
        <>
          Integrating your CRM and accounting systems eliminates duplicate data
          entry, automates quotation and invoice processes, and ensures your
          sales and finance teams are always in sync. It also improves
          visibility across your customer lifecycle.
        </>
      ),
    },
    {
      question:
        "What makes Pepper Cloud the best CRM with accounting software integration?",
      answer: (
        <>
          Pepper Cloud offers real-time data sync, auto-populated quotation
          details, and instant status tracking with tools like QuickBooks and
          Xero. It also features workflow automation, custom templates, and an
          intuitive interface built for growing teams.
        </>
      ),
    },
    {
      question: "Does Pepper Cloud CRM support both QuickBooks and Xero?",
      answer: (
        <>
          Yes, Pepper Cloud CRM integrates seamlessly with both QuickBooks and
          Xero, offering two-way sync, quotation tracking, and automated
          updates—making it a flexible and scalable accounting CRM system.
        </>
      ),
    },
    {
      question: "Can I automate follow-ups based on quotation status?",
      answer: (
        <>
          Absolutely. Pepper Cloud’s workflow automation allows you to trigger
          emails and internal tasks based on changes in quotation status, such
          as acceptance, decline, or pending.
        </>
      ),
    },
    {
      question:
        "Is this integration suitable for small and medium-sized businesses?",
      answer: (
        <>
          Yes. Whether you’re a freelancer, startup, or growing business, Pepper
          Cloud CRM and accounting software integration is designed to simplify
          operations and scale with you—without complex setup.
        </>
      ),
    },
    {
      question: "How difficult is it to set up the integration?",
      answer: (
        <>
          Not difficult at all. Pepper Cloud’s user-friendly setup process
          requires no technical expertise. Just connect your QuickBooks or Xero
          account, map your fields, and you’re ready to go in minutes.
        </>
      ),
    },
  ];

  const clientList = [
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "Zoho CRM",
    "HubSpot CRM",
    "Salesforce CRM",
    "Insightly CRM",
  ];
  return (
    <main>
      <SEO
        title={
          "CRM Accounting and Finance Integration with Xero and QuickBooks"
        }
        pathname={
          "https://peppercloud.com//user-based-tools/crm-accounting-finance-integration"
        }
        keywords="CRM Accounting and Finance Integration, Xero, QuickBooks, Accounting and Finance Integration"
        description={
          "Integrate Xero and QuickBooks with Pepper Cloud CRM to streamline invoicing, automate billing workflows, and sync financial data in real time. Simplify your accounting and sales processes today."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        scripts={[`gtag('event', 'whatsapp_support_crm_generate_lead', {});`]}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What are the benefits of WhatsApp CRM for customer service?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "WhatsApp CRM improves response speed, ensures no query goes unanswered, enables team collaboration, and provides complete visibility into customer interactions. It also helps SMEs scale customer service without increasing staff costs.",
                },
              },
              {
                "@type": "Question",
                name: "What are the top 3 features which make our CRM ideal for customer support on WhatsApp?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Our CRM offers a smart ticketing system with automation rules, a multi-channel inbox with complete customer history, and real-time agent availability and assignment, making it ideal for customer support on WhatsApp.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best WhatsApp CRM for customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The best WhatsApp CRM should integrate seamlessly with your existing systems, offer automation to handle large volumes, provide detailed analytics, and be easy to use for your support team. For SMEs, it should also be scalable and cost-effective.",
                },
              },
              {
                "@type": "Question",
                name: "Can WhatsApp CRM work for small and medium businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. WhatsApp CRM is designed to scale with your business. SMEs benefit from automation, ticket management, and customer history features without needing large support teams.",
                },
              },
              {
                "@type": "Question",
                name: "How secure is customer data in a WhatsApp CRM system?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Most WhatsApp CRM systems follow strict compliance with WhatsApp Business API policies and data protection standards. This ensures conversations and customer data remain secure and private.",
                },
              },
              {
                "@type": "Question",
                name: "Does WhatsApp CRM integrate with other business tools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. A good WhatsApp CRM integrates with sales CRM, payment gateways, project management tools, and marketing platforms, helping you unify operations across teams.",
                },
              },
              {
                "@type": "Question",
                name: "How does WhatsApp CRM improve customer retention?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "By responding faster, personalising interactions, and keeping track of every customer’s history, WhatsApp CRM helps businesses build stronger relationships, increasing loyalty and repeat business.",
                },
              },
              {
                "@type": "Question",
                name: "What role does AI play in WhatsApp CRM for customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI enhances support by powering chatbots, automating repetitive queries, analysing sentiment, and assisting agents with quick, accurate responses—improving both efficiency and customer experience.",
                },
              },
              {
                "@type": "Question",
                name: "Can multiple team members manage the same customer conversation?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. With collaboration tools inside WhatsApp CRM, multiple agents can view, comment, and resolve queries together without losing context or duplicating work.",
                },
              },
              {
                "@type": "Question",
                name: "How does WhatsApp CRM support omnichannel communication?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A WhatsApp CRM combines WhatsApp, email, and other messaging platforms into one inbox, allowing teams to respond consistently across all channels.",
                },
              },
            ],
          },
        ]}
      />

      <section className={classes.whatsappSection}>
        <div className="container">
          <div className={classes.aiSectionContainer}>
            <div className={classes.aiSectionLeft}>
              <motion.h1
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-64 font-white"
              >
                Smart CRM accounting software tools
              </motion.h1>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 font-white"
              >
                Pepper Cloud CRM accounting software simplifies sales and
                finance with QuickBooks and Xero integration automating quotes,
                reducing manual tasks, and keeping teams aligned.
              </motion.p>
              <div className={classes.listContainer}>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white  font-18">
                    Real-time financial visibility
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Faster, error-free quotations
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Smarter workflows with automation
                  </p>
                </motion.div>
              </div>
              <div className="buttonContaienr">
                <Link
                  className="primaryButton font-16 font-wix-medium font-white"
                  to="/contact/?utm_source=CRM+email+integration&utm_medium=Book+a+demo"
                >
                  Book a demo
                </Link>
              </div>
            </div>
            <div className={classes.aiSectionRight}>
              <LazyImage
                source={heroSectionImg}
                width="100%"
                alt="CRM software with Gmail integration"
              />
            </div>
          </div>
        </div>
      </section>

      <section className={classes.Client}>
        <div className="container">
          <p className="font-24 font-wix-semibold">
            Pepper Cloud CRM – Trusted by SMEs across industries
          </p>
          <Swiper
            modules={[Autoplay]}
            className={classes.adaptSlider}
            grabCursor={true}
            loop={true}
            slidesPerView="auto"
            spaceBetween={30}
            speed={6000} // slow speed for smooth flow
            autoplay={{
              delay: 0, // no delay, continuous movement
              disableOnInteraction: false, // keeps looping even on hover/touch
            }}
            freeMode={true} // allows continuous smooth scroll
            freeModeMomentum={false} // disables snapping effect
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 50,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 100,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 100,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 100,
              },
            }}
          >
            {clientList.map((point) => (
              <SwiperSlide className="client-logo">
                <div>
                  <img
                    // alt={point.card.alt}
                    src={point.img}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      <section className={classes.broadcastContainer}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Bring your accounting and CRM together
            </motion.h2>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 font-white"
            >
              Unify sales and finance with Pepper Cloud CRM. Integrate
              QuickBooks or Xero to automate quotes, reduce manual work, and get
              full financial visibility all in one platform.
            </motion.h2>
          </div>
        </div>
        <Swiper
          slidesPerView={1}
          centeredSlides={true}
          modules={[Autoplay]}
          speed={5000}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          spaceBetween={30}
          grabCursor={true}
          className={classes.workflowBroadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
              centeredSlides: false,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: "auto",
              centeredSlides: true,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {broadcastList.map((point, index) => (
            <SwiperSlide
              className={classes.broadcastBox}
              style={{ background: point.background }}
            >
              <div className={classes.broadcastLeftContainer}>
                <p className="font-40 font-wix-medium font-white">
                  {point.heading}
                </p>
                <p className="font-18 font-wix-regular font-white mt10 mb20">
                  {point.content}
                </p>
                {point.points.map((pointItem, index) => (
                  <div key={index} className={classes.cardPointer}>
                    <LazyImage
                      source={point.checkIcon}
                      alt={"pointer"}
                      className={clsx(classes.cardPointer)}
                    />
                    <div className={classes.cardPointerContent}>
                      <p className="font-wix-semibold font-18 font-white">
                        {pointItem.title}
                      </p>
                      <p className="font-wix-regular font-16 font-white">
                        {pointItem.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              <div className={classes.broadcastRightContainer}>
                <img
                  src={point.img}
                  alt={point.alt}
                  className={classes.broadcastImg}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className={classes.benefitSection1}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 "
            >
              Benefits of using <br />
              CRM accounting software
            </motion.h2>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 "
            >
              Unify sales and finance to close deals faster, reduce errors, and
              gain full visibility. With Pepper Cloud CRM, automate tasks, boost
              accuracy, and make smarter decisions in real time.
            </motion.h2>
          </div>

          <div className="benefits">
            <div className="featureColumn">
              <div className="featureContainer">
                <LazyImage
                  source={benefit1Icon1}
                  alt={"WhatsApp CRM for customer service"}
                  className={classes.featureIcon}
                  // alt={listItem.alt}
                />
                <p className="font-wix-semibold font-24 color-black2">
                  Real-time quotation sync
                </p>
                <p className="font-wix-medium font-18 color-black3">
                  Keep your quotations up to date across both CRM and accounting
                  platforms. Whether using QuickBooks or Xero, your team always
                  works with the latest data—no need for duplicate entry or
                  follow-ups.
                </p>
              </div>

              <div className="featureContainer">
                <LazyImage
                  source={benefit1Icon2}
                  alt={"WhatsApp CRM for customer service"}
                  className={classes.featureIcon}
                  // alt={listItem.alt}
                />
                <p className="font-wix-semibold font-24 color-black2">
                  Faster quote generation
                </p>
                <p className="font-wix-medium font-18 color-black3">
                  Use ready-made templates and auto-fill features to generate
                  accurate estimates in seconds. Pull product details, pricing,
                  and tax rates directly from your accounting system with one
                  click.
                </p>
              </div>
            </div>

            <div className="imageColumn">
              <LazyImage
                source={benefit1Img}
                alt={"WhatsApp CRM for customer service"}
                // alt={listItem.alt}
              />
            </div>

            <div className="featureColumn">
              <div className="featureContainer">
                <LazyImage
                  source={benefit1Icon3}
                  alt={"WhatsApp CRM for customer service"}
                  className={classes.featureIcon}
                  // alt={listItem.alt}
                />
                <p className="font-wix-semibold font-24 color-black2">
                  Reduce manual errors
                </p>
                <p className="font-wix-medium font-18 color-black3">
                  Eliminate the need to copy and paste data between systems.
                  Pepper Cloud CRM and accounting software integration ensures
                  data accuracy by automating tax, pricing, and product inputs.
                </p>
              </div>

              <div className="featureContainer">
                <LazyImage
                  source={benefit1Icon4}
                  alt={"WhatsApp CRM for customer service"}
                  className={classes.featureIcon}
                  // alt={listItem.alt}
                />
                <p className="font-wix-semibold font-24 color-black2">
                  Smarter workflow automation
                </p>
                <p className="font-wix-medium font-18 color-black3">
                  Set up email alerts and status updates based on quotation
                  changes. With built-in workflow automation, your teams can
                  respond quickly when an estimate is accepted, declined, or
                  pending.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Pepper Cloud - Best CRM with accounting software integration
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 color-black1"
            >
              Connect QuickBooks or Xero to automate tasks, reduce errors, and
              manage sales and finance in one place.
            </motion.p>
          </div>
        </div>
        <Swiper
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={false}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          // freeMode={true}
          className={classes.broadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1.3,
              slidesPerGroup: 1,
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 3.3,
              centeredSlides: false,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {growingList.map((feature) => (
            <SwiperSlide className={classes.featureContainer}>
              <LazyImage
                source={feature.icon}
                alt={"WhatsApp CRM for customer service"}
                className={classes.featureIcon}
                // alt={listItem.alt}
              />
              <p className="font-wix-semibold font-24 color-black2">
                {feature.heading}
              </p>
              <p className="font-wix-medium font-18 color-black3">
                {feature.text}
              </p>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div> */}
      </section>

      <section className={classes.combineSection}>
        <div className={classes.integrationContent}>
          <motion.h2
            className="font-wix-semibold font-56 color-white"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Pepper Cloud CRM features tailored for success
          </motion.h2>
        </div>

        <section className="sales-dev-logo-carousel">
          <div className="logos-container">
            <div className="scroll-container">
              <div
                className="logos-row-2"
                data-direction="left"
                data-speed="0.8"
              >
                <div className="logos-track">
                  {logotrack1.map((logo) => (
                    <div
                      className="logo-2 logo font-18 font-wix-medium"
                      key={logo.title}
                    >
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row-2"
                data-direction="right"
                data-speed="0.4"
              >
                <div className="logos-track">
                  {logotrack2.map((logo) => (
                    <div className="logo-2 logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row-2"
                data-direction="left"
                data-speed="0.8"
              >
                <div className="logos-track">
                  {logotrack3.map((logo) => (
                    <div className="logo-2 logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>

      <section className={classes.compareSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Top 5 CRM accounting tool integrations in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` &&
                        "font-wix-semibold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        {faq.title ? (
                          <React.Fragment>
                            {" "}
                            <div className={classes.topFiveHeader}>
                              <h3 className="font-20 font-wix-semibold">
                                {faq.title}
                              </h3>
                              <img
                                alt="Arrow"
                                className={clsx(
                                  classes.downArrow,
                                  `${outerIndex}-${innerIndex}` ===
                                    activeAccordian && "active"
                                )}
                                src={downArrow}
                              />
                            </div>
                            <Collapse
                              className={classes.body}
                              in={
                                activeAccordian ===
                                `${outerIndex}-${innerIndex}`
                              }
                            >
                              <p className="font-18 font-wix-regular color-black2">
                                {faq.desc}
                              </p>
                            </Collapse>{" "}
                          </React.Fragment>
                        ) : (
                          <p
                            className={clsx(
                              classes.faqDesc,
                              "font-18 font-wix-regular color-black2"
                            )}
                          >
                            {faq.desc}
                          </p>
                        )}
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={"Frequently asked questions about CRM accounting software"}
        />
      </div>

      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Sync sales and finance. Grow faster with CRM accounting software
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=CRM+email+integration&utm_medium=Show+me+how"
            >
              Show me how
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AccountingAndFinance;
